import React, { Component } from 'react'
import { Progress, Tooltip, Icon } from "antd"
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import "./AttachedFileProgress.css"
class AttachedFileProgress extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const { attachedFile, intl, cancelUpload, cleanAttachedFile, isUploadingFile } = this.props

        let formattedName = ""
        const isLargeName = (attachedFile.name && attachedFile.name.length > 15)
        if (isLargeName) {
            formattedName = attachedFile.name.slice(0, 12) + "..."
        }

        return (
            <div className="flex-row">
                <div className="flex-row text-format">
                    <p>{`${intl.formatMessage({ id: "attached_file" })}:`}&nbsp;</p>
                    {
                        (isLargeName) ?
                            <Tooltip title={attachedFile.name} >
                                <p>{formattedName}</p>
                            </Tooltip>
                            :
                            <p>{attachedFile.name}</p>
                    }
                    <p className="percent-progress">
                        {Math.trunc(attachedFile.progress)}% {intl.formatMessage({ id: "upload_progress_message" })}
                    </p>

                </div>
                <div style={{ width: "35%", display: "flex", flexDirection: "row ", paddingLeft: "4px" }}>
                    <Progress
                        percent={attachedFile.progress}
                        size="small"
                        status={attachedFile.state === 'inprogress'
                            ? 'active'
                            : attachedFile.state === 'error'
                                ? 'exception'
                                : 'success'}
                        strokeWidth={6}
                        showInfo={false} />
                    {(attachedFile.state === 'inprogress') &&
                        <div className="action-icon-wraper">
                            <Tooltip placement="top" title={intl.formatMessage({ id: "cancel_upload" })}>
                                <Icon type="close-circle" className="icon-size"
                                    style={{

                                        color: "red"
                                    }}
                                    onClick={cancelUpload} />
                            </Tooltip>
                        </div>
                    }
                    {
                        (attachedFile.state === "waiting" && !isUploadingFile) &&
                        <div className="action-icon-wraper">
                            <Tooltip placement="top" title={intl.formatMessage({ id: "quit_element" })}>
                                <Icon type="delete" className="icon-size" style={{

                                    color: "white"

                                }} onClick={cleanAttachedFile} />
                            </Tooltip>

                        </div>
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {

    return {}
}

const mapDispatchToProps = {}

export default injectIntl(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(AttachedFileProgress))
)
